import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { EASE } from "./Reveal";

const LINKS = [
  { label: "Work", href: "#work" },
  { label: "Studio", href: "#studio" },
  { label: "Services", href: "#services" },
  { label: "Contact", href: "#contact" },
];

const scrollTo = (e, href) => {
  e.preventDefault();
  if (window.__lenis) {
    window.__lenis.scrollTo(href, { duration: 1.6 });
  } else {
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  }
};

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <header className="fixed top-0 inset-x-0 z-50 bg-[#050505]/70 backdrop-blur-md border-b border-white/10" data-testid="navbar">
        <div className="flex items-center justify-between px-6 md:px-12 h-16 md:h-20">
          <a
            href="#top"
            onClick={(e) => scrollTo(e, "#top")}
            className="flex items-center gap-3"
            data-testid="nav-logo-link"
            aria-label="ETMB home"
          >
            <img src="/assets/etmb-logo.png" alt="ETMB Design Build" className="h-9 md:h-11 w-auto" />
          </a>
          <nav className="hidden md:flex items-center gap-10">
            {LINKS.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={(e) => scrollTo(e, l.href)}
                className="link-line text-xs tracking-[0.25em] uppercase text-ash hover:text-paper transition-colors duration-300"
                data-testid={`nav-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={(e) => scrollTo(e, "#contact")}
              className="border border-white/40 px-5 py-2.5 text-xs tracking-[0.25em] uppercase hover:bg-white hover:text-black transition-colors duration-300"
              data-testid="nav-cta-button"
            >
              Start a Project
            </a>
          </nav>
          <button
            className="md:hidden text-paper p-2"
            onClick={() => setOpen(true)}
            aria-label="Open menu"
            data-testid="mobile-menu-open-button"
          >
            <Menu size={22} strokeWidth={1.5} />
          </button>
        </div>
      </header>

      <AnimatePresence>
        {open && (
          <motion.div
            className="fixed inset-0 z-[80] bg-[#050505] flex flex-col"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4, ease: EASE }}
            data-testid="mobile-menu"
          >
            <div className="flex items-center justify-between px-6 h-16 border-b border-white/10">
              <img src="/assets/etmb-logo.png" alt="ETMB" className="h-9 w-auto" />
              <button
                onClick={() => setOpen(false)}
                className="text-paper p-2"
                aria-label="Close menu"
                data-testid="mobile-menu-close-button"
              >
                <X size={22} strokeWidth={1.5} />
              </button>
            </div>
            <nav className="flex flex-col justify-center flex-1 px-6 gap-2">
              {LINKS.map((l, i) => (
                <span key={l.label} className="block overflow-hidden">
                  <motion.a
                    href={l.href}
                    onClick={(e) => {
                      setOpen(false);
                      scrollTo(e, l.href);
                    }}
                    className="block font-display text-5xl uppercase font-bold tracking-tight py-3 text-paper"
                    initial={{ y: "110%" }}
                    animate={{ y: 0 }}
                    transition={{ duration: 0.8, ease: EASE, delay: 0.1 + i * 0.07 }}
                    data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                  >
                    {l.label}
                  </motion.a>
                </span>
              ))}
            </nav>
            <div className="px-6 pb-10 text-xs tracking-[0.25em] uppercase text-ash">Design + Build — One Team</div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
